import React from 'react';

import HeartIcon from '@atlaskit/icon/core/heart';

export const ToneEmpatheticIcon = () => (
	<HeartIcon label="" color="currentColor" spacing="spacious" />
);
